import { both, complement, isEmpty, isNil } from 'ramda';
export const isPresent = both(complement(isEmpty), complement(isNil));
export default isPresent;
